import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSurveyContext } from '../../context/SurveyContext';
import QuestionSection from './QuestionSection';
import Section1Break from './Section1Break';
import Section1MidBreak from './Section1MidBreak';
import Section2MidBreak from './Section2MidBreak';
import Section2Break from './Section2Break';
import SurveyEnd from './SurveyEnd';

const Start = () => {
  const { surveyState } = useSurveyContext();
  const navigate = useNavigate();
  const [currentComponent, setCurrentComponent] = useState<React.ReactNode>(null);

  // Handle refresh - if survey hasn't started, redirect to beginning
  useEffect(() => {
    if (!surveyState.hasStarted) {
      navigate('/survey/beginning');
      return;
    }
  }, [surveyState.hasStarted, navigate]);

  // Determine which component to render based on current step
  useEffect(() => {
    if (!surveyState.hasStarted) return;

    switch (surveyState.currentStep) {
      case 'start':
        // Show the first section
        setCurrentComponent(<QuestionSection />);
        break;
      case 'section-1':
        setCurrentComponent(<QuestionSection />);
        break;
      case 'break-1':
        setCurrentComponent(<Section1Break />);
        break;
      case 'break-1-mid':
        setCurrentComponent(<Section1MidBreak />);
        break;
      case 'break-2':
        setCurrentComponent(<Section2Break />);
        break;
      case 'break-2-mid':
        setCurrentComponent(<Section2MidBreak />);
        break;
      case 'section-2':
        setCurrentComponent(<QuestionSection />);
        break;
      case 'section-3':
        setCurrentComponent(<QuestionSection />);
        break;
      case 'end':
        setCurrentComponent(<SurveyEnd />);
        break;
      default:
        // Default to first section
        setCurrentComponent(<QuestionSection />);
    }
  }, [surveyState.currentStep, surveyState.hasStarted, navigate]);

  // If survey hasn't started, show loading
  if (!surveyState.hasStarted) {
    return <div>Redirecting...</div>;
  }

  // Render the appropriate component
  return <>{currentComponent}</>;
};

export default Start; 